export var DEFAULT_OWNER_ID = 202100;
export var CONTAINER_ID_PREFIX = 'adfox';